export type Observer<T> = (value: T) => void;

export type Subscription = { unsubscribe: () => void };

class Observable<T> {
    private observers: Observer<T>[] = [];

    public subscribe(observer: Observer<T>) {
        this.observers.push(observer);
        return {
            unsubscribe: () => {
                this.observers = this.observers.filter((o) => o !== observer);
            },
        };
    }

    notify(data: T) {
        this.observers.forEach((o) => {
            try {
                o(data);
            } catch {}
        });
    }
}

export default Observable;
